import { path } from 'ramda';
import {  Snackbar, Alert  } from "@mui/material";
import { ReduxComponentInterface } from 'edocatbase/Global';
import { ModalInterface } from 'edocatbase/Modal';
import { Dispatch } from 'redux';
import { toggleModal } from '../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

interface ResponseModalProps extends ModalInterface, ReduxComponentInterface {
  items: {
    text: string;
    hideTimeout?: number;
    severity: 'success' | 'warning' | 'info' | 'error';
    formInstanceId?: string;
    anchorOrigin?: {
      vertical: string;
      horizontal: string;
    };
    url?: string;
  };
  isOpen: boolean;
}

class ResponseModal extends React.PureComponent<ResponseModalProps> {
  static defaultProps = {
    hideTimeout: 3000,
  };

  handleClose = () => {
    const { actions, onClose, items } = this.props;
    onClose && onClose();
    actions.toggleModal(false, 'responseModal', items, items?.formInstanceId);
    items?.url && (window.location.href = items.url);
  };

  render() {
    const { isOpen } = this.props;
    const items: any = this?.props?.items ?? {};
    const { text, severity, hideTimeout, anchorOrigin } = items;
    return (
      <Snackbar
        anchorOrigin={anchorOrigin || { vertical: 'bottom', horizontal: 'right' }}
        onClose={this.handleClose}
        open={isOpen || false}
        autoHideDuration={hideTimeout ?? 3000}
        id={`${severity}Snackbar`}
      >
        <Alert onClose={this.handleClose} severity={severity} style={{ whiteSpace: 'pre' }}>
          {text}
        </Alert>
      </Snackbar>
    );
  }
}

const mapStateToProps = (state: any, props: { reducerPath?: string[] }) => {
	if (!state) return {};
  const retProps = props.reducerPath ? path(props.reducerPath, state) : state?.modal?.responseModal;
  return retProps || {};
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ toggleModal }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResponseModal);
